import { z } from "zod";
import { LocationsSchema } from "./Locations";

export type Rooms = z.infer<typeof RoomsSchema>;
export const RoomsSchema = z.object({
  locations: z.array(LocationsSchema),
  total_count: z.number(),
});
